"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENTAL_CREDIT_TYPES = void 0;
exports.RENTAL_CREDIT_TYPES = {
    EXCHANGE: 'exchange',
    PREVIOUSLY_DEPOSITED: 'previously_deposited',
    WAIVE_UNPAID: 'waive_unpaid'
};
